import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, useLogin, useText } from "@sveabank/cc-common";

type Props = {
	onClose: () => void;
};

const FinalizeButtonGroup = ({ onClose }: Props) => {
	const { doLogout } = useLogin();
	const [t, texts] = useText();

	return (
		<ButtonGroup>
			<Button onPress={() => doLogout()} width="full">
				{t(texts.modals.finalizedApplication.logout)}
			</Button>
			<Button variant="secondary" width="full" onPress={onClose}>
				{t(texts.modals.finalizedApplication.close)}
			</Button>
		</ButtonGroup>
	);
};

export default FinalizeButtonGroup;
